/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
/* Generated: 2026-08-20T13:04:09.056Z */
import { lazy } from 'react';

import { ModalName } from './modals-names';

export const MODAL_COMPONENTS_DICT = {
  [ModalName.AgeVerificationModal]: {
    Component: lazy(
      () => import('@/features/age-verification/ui/AgeVerificationModal.modal')
    ),
  },
  [ModalName.BuyBoinkersBoostModal]: {
    Component: lazy(
      () =>
        import(
          '@/entities/market/ui/buy-boinkers-boost-modal/BuyBoinkersBoostModal.modal'
        )
    ),
  },
  [ModalName.BuyXpBoostModal]: {
    Component: lazy(
      () => import('@/entities/leaderboards/ui/buy-xp-boost-modal/BuyXpBoostModal.modal')
    ),
  },
  [ModalName.FifthDayNotificationModal]: {
    Component: lazy(
      () =>
        import(
          '@/entities/task/ui/reward-notification-modal/FifthDayNotificationModal.modal'
        )
    ),
  },
  [ModalName.GrabLbPrizesModal]: {
    Component: lazy(
      () =>
        import('@/entities/leaderboards/ui/grab-lb-prizes-modal/GrabLbPrizesModal.modal')
    ),
  },
  [ModalName.NewFeatureAlertModal]: {
    Component: lazy(
      () =>
        import(
          '@/widgets/new-feature-alert/ui/new-feature-alert-modal/NewFeatureAlertModal.modal'
        )
    ),
  },
  [ModalName.NewUsersRefPageModal]: {
    Component: lazy(
      () =>
        import('@/pages/profile-page/ui/new-user-ref-modal/NewUsersRefPageModal.modal')
    ),
  },
  [ModalName.NewXpModal]: {
    Component: lazy(() => import('@/widgets/xp-modal/ui/NewXpModal.modal')),
  },
  [ModalName.OnboardingModal_R0]: {
    Component: lazy(
      () =>
        import('@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R0.modal')
    ),
  },
  [ModalName.OnboardingModal_R1]: {
    Component: lazy(
      () =>
        import('@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R1.modal')
    ),
  },
  [ModalName.OnboardingModal_R3]: {
    Component: lazy(
      () =>
        import('@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R3.modal')
    ),
  },
  [ModalName.OnboardingModal_R5]: {
    Component: lazy(
      () =>
        import('@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R5.modal')
    ),
  },
  [ModalName.OnboardingModal_R7]: {
    Component: lazy(
      () =>
        import('@/widgets/main-page/ui/modals/onboarding-modals/OnboardingModal_R7.modal')
    ),
  },
  [ModalName.PlaycoinBoostModal]: {
    Component: lazy(
      () => import('@/widgets/boost/ui/playcoin-boost-modal/PlaycoinBoostModal.modal')
    ),
  },
  [ModalName.PlaydeckSubscriptionModal]: {
    Component: lazy(
      () =>
        import(
          '@/widgets/playdeck-subscription-widget/playdeck-subscription-modal/PlaydeckSubscriptionModal.modal'
        )
    ),
  },
  [ModalName.PvpModal]: {
    Component: lazy(() => import('@/features/pvp/ui/modal/PvpModal.modal')),
  },
  [ModalName.StateIoModal]: {
    Component: lazy(
      () => import('@/entities/market/ui/state-io-modal/StateIoModal.modal')
    ),
  },
  [ModalName.TenthDayNotificationModal]: {
    Component: lazy(
      () =>
        import(
          '@/entities/task/ui/reward-notification-modal/TenthDayNotificationModal.modal'
        )
    ),
  },
  [ModalName.TopModal]: {
    Component: lazy(
      () => import('@/widgets/main-page/ui/modals/top-modal/TopModal.modal')
    ),
  },
  [ModalName.WalletBlockModal]: {
    Component: lazy(
      () => import('@/widgets/wallet-block-modal/ui/WalletBlockModal.modal')
    ),
  },
  [ModalName.Wheel100TonPrizeModal]: {
    Component: lazy(
      () =>
        import(
          '@/entities/wheel/ui/wheel-100-ton-prize-modal/Wheel100TonPrizeModal.modal'
        )
    ),
  },
  [ModalName.WheelAdModal]: {
    Component: lazy(
      () => import('@/entities/wheel/ui/wheel-ad-modal/WheelAdModal.modal')
    ),
  },
};
